module.exports = __webpack_public_path__ + "img/banner.a973302d.png";